import { render, staticRenderFns } from "./UiFormField.vue?vue&type=template&id=2f77f692&lang=pug&"
import script from "./UiFormField.vue?vue&type=script&lang=js&"
export * from "./UiFormField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports